export default __webpack_public_path__ + "static/media/attraction6.89ab816d.jpg";